import { FormItemProps } from "@app/components/forms/types/props";
import { RadioGroupSchema } from "@app/components/forms/types/schema";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  RadioGroup,
  RadioGroupItem,
} from "@shortsworks/ui";
import { cn } from "@shortsworks/ui/lib/utils";

export const FormRadioGroup = ({
  form,
  schema,
  ...rest
}: FormItemProps<RadioGroupSchema>) => {
  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => {
        return (
          <FormItem
            className={cn(
              "space-y-0",
              schema.appearance?.border && "rounded-md border p-3 shadow-sm",
              schema.behavior?.hidden && "hidden",
            )}
          >
            <div className="mb-4">
              <FormLabel>
                {typeof schema.label === "function"
                  ? schema.label(form.getValues())
                  : schema.label}
              </FormLabel>
              {schema.description && (
                <FormDescription>
                  {typeof schema.description === "function"
                    ? schema.description(form.getValues())
                    : schema.description}
                </FormDescription>
              )}
            </div>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                value={field.value}
                className={cn(
                  "flex flex-col space-y-1",
                  schema.optionLayout === "horizontal" &&
                    "flex-row space-x-3 space-y-0",
                )}
              >
                {schema.options.map((item, index) => (
                  <FormItem
                    key={`${schema.id}-${item.value}-${index}`}
                    className={cn(
                      "flex flex-row space-y-1 relative",
                      schema.hideIndicator
                        ? "space-x-0 items-center"
                        : "space-x-3 items-start",
                      schema.hideIndicator &&
                        "[&:has([data-state=checked])>div>label]:border-primary",
                    )}
                  >
                    <FormControl>
                      <RadioGroupItem
                        className={cn(
                          "mt-0.5",
                          schema.hideIndicator && "sr-only",
                        )}
                        value={item.value}
                      />
                    </FormControl>
                    <div className="space-y-1 leading-none">
                      <FormLabel
                        className={cn(
                          "flex",
                          schema.hideIndicator &&
                            "rounded-md border-2 border-muted p-2 hover:border-accent",
                        )}
                      >
                        {typeof item.label === "function"
                          ? item.label(form.getValues())
                          : item.label}
                      </FormLabel>
                      {item.description && (
                        <FormDescription>
                          {typeof item.description === "function"
                            ? item.description(form.getValues())
                            : item.description}
                        </FormDescription>
                      )}
                    </div>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
